import { ErrorHandler, Injector, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HTTP_INTERCEPTORS, HttpBackend, HttpClient, HttpClientModule } from '@angular/common/http'
import { SharedModule } from './shared/shared.module'
import { ToastrModule } from 'ngx-toastr'
import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core'
import { NgxSpinnerModule } from 'ngx-spinner'
import { AuthInterceptor, RetryInterceptor, SpinnerInterceptorService } from 'sbs-common'
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader'
import { GlobalErrorHandler } from './shared/services/global-error-handler'
import { ServiceWorkerModule } from '@angular/service-worker'
import { environment } from '../environments/environment'

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/common/i18n/', suffix: '.json' },
    { prefix: './assets/i18n/', suffix: '.json' },
  ])
}

// export class MyMissingTranslationHandler implements MissingTranslationHandler {
//   handle(params: MissingTranslationHandlerParams) {
//     const english = params.translateService.get('en')
//     // return params.translateService.get('en')
//     // return `??Missing key: ${params.key}`
//     return english[params.key]
//   }
// }

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SharedModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
      // missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
    }),
    NgxSpinnerModule,
    ServiceWorkerModule.register('./ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: RetryInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptorService, multi: true },
  ],
})
export class AppModule {
  //https://stackoverflow.com/questions/56748951/angular-inject-service-into-base-class-but-not-in-sub-class-and-use-the-parent-s
  constructor(injector: Injector) {
    AppInjector.setInjector(injector) // save a injector ref 💾
  }
}

export class AppInjector {
  private static injector: Injector

  static setInjector(injector: Injector) {
    AppInjector.injector = injector
  }

  static getInjector(): Injector {
    return AppInjector.injector
  }
}
